/**
 * Returns the human-readable label for an application role value.
 */
export function getApplicationRoleLabel(role: string): string {
  switch (role) {
    case 'Admin':
      return 'Admin';
    case 'Manager':
      return 'Manager';
    case 'User':
      return 'User';
    default:
      return role;
  }
}

/**
 * Returns the selectable role options filtered by the caller's workspace role.
 * - TENANT_OWNER → Admin, Manager, User
 * - TENANT_ADMIN → Manager, User
 * - COMPANY_ADMIN → User
 * Falls back to all options if no known restricting role is detected.
 */
export function getPermittedRoleOptions(
  callerWorkspaceRoles: string[]
): Array<{ value: 'Admin' | 'Manager' | 'User'; label: string }> {
  const all: Array<{ value: 'Admin' | 'Manager' | 'User'; label: string }> = [
    { value: 'Admin', label: 'Admin' },
    { value: 'Manager', label: 'Manager' },
    { value: 'User', label: 'User' },
  ];

  const has = (role: string) =>
    callerWorkspaceRoles.some((r) => r.toUpperCase() === role.toUpperCase());

  if (has('TENANT_OWNER')) return all;
  if (has('TENANT_ADMIN')) return all.filter((o) => o.value !== 'Admin');
  if (has('COMPANY_ADMIN')) return all.filter((o) => o.value === 'User');

  return all;
}
